// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a5da5dd4","732":"94e61a94"}[chunkId] + ".chunk.js";
};